import { render, staticRenderFns } from "./InstoApi.vue?vue&type=template&id=3c3b8c66&scoped=true"
import script from "./InstoApi.vue?vue&type=script&lang=js"
export * from "./InstoApi.vue?vue&type=script&lang=js"
import style0 from "./InstoApi.vue?vue&type=style&index=0&id=3c3b8c66&prod&DownloadModal=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3b8c66",
  null
  
)

export default component.exports